import { Typography } from 'antd';
import styled from 'styled-components';

export const TitleStyled = styled(Typography.Title)`
  margin: 0px;
`;
